import React, { useState, useEffect } from "react";
import "../../Css/Manavseva.css";

function Manavseva() {
  const [files, setFiles] = useState([]);
  const [baseUrl, setBaseUrl] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await fetch(
          "https://api.gkaglobal.org/restgka/admin/manavsevafile.php"
        );
        const data = await response.json();

        if (data.status === "success") {
          setBaseUrl(data.baseurl);

          const imageMap = {};
          data.image_files.forEach((imageFile) => {
            const imageNameWithoutExt = imageFile
              .split(".")
              .slice(0, -1)
              .join(".");
            imageMap[imageNameWithoutExt] = data.baseurl + imageFile;
          });

          const fileData = data.pdf_files.map((fileUrl) => {
            const fileNameWithoutExt = fileUrl
              .split(".")
              .slice(0, -1)
              .join(".");
            return {
              name: fileNameWithoutExt,
              pdfUrl: data.baseurl + fileUrl,
              imageUrl: imageMap[fileNameWithoutExt] || "",
            };
          });

          setFiles(fileData);
        } else {
          setError("Error: " + data.message);
        }
      } catch (err) {
        setError("Failed to retrieve files. Error: " + err.message);
      }
    };

    fetchFiles();
  }, [baseUrl]);

  return (
    <div className="manavseva-box1">
      <h2 className="h2">Manavseva</h2>

      <div>
        {error ? (
          <p>{error}</p>
        ) : files.length > 0 ? (
          <div id="file-list1">
            {files.map((file, index) => (
              <div key={index} className="file-item1">
                {file.imageUrl && <img src={file.imageUrl} alt="Preview" />}
                <p className="manav1">
                  <a
                    href={file.pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {file.name}
                  </a>
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p>No PDF files found.</p>
        )}
      </div>
    </div>
  );
}

export default Manavseva;
